import { toast } from "sonner";
import { Link2, Share2 } from "lucide-react";
import { Button } from "@/components/ui/button";

const copyText = (t, msg) => navigator.clipboard.writeText(t).then(() => toast.success(msg), () => toast.error("Couldn't copy. Copy it manually."));

export const ShareBar = ({ tool, jobId, res, score }) => {
  const link = `${window.location.origin}/ai-studio?tool=${encodeURIComponent(tool.id)}${jobId ? `&job=${encodeURIComponent(jobId)}` : ""}`;
  const text = score != null ? `My ATS pass rate is ${Math.round(score)}%. Checked with RPOPRO.co` : `${res?.title || tool.title}, built with RPOPRO.co`;
  const share = async () => {
    if (navigator.share) { try { await navigator.share({ title: tool.title, text, url: link }); return; } catch (e) { if (e?.name === "AbortError") return; } }
    copyText(`${text}\n${link}`, "Copied to share");
  };
  return (
    <div className="mt-6 flex flex-wrap items-center gap-2 border-t border-[#27272A] pt-4" data-testid="share-bar">
      <span className="mr-auto text-xs text-zinc-500">Share this result</span>
      <Button size="sm" variant="outline" onClick={share} data-testid="share-result-button"><Share2 className="h-4 w-4" />Share</Button>
      <Button size="sm" variant="outline" onClick={() => copyText(link, "Link copied")} data-testid="copy-link-button"><Link2 className="h-4 w-4" />Copy link</Button>
    </div>
  );
};
